document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".actu-item");

  const prevBtn = document.querySelector(".actus-arrow-left");
  const nextBtn = document.querySelector(".actus-arrow-right");
  const indicator = document.querySelector(".actus-page-indicator");

  let currentPage = 0;

  function getPerPage() {
    const width = window.innerWidth;

    if (width >= 1200) return 4;
    if (width >= 992) return 3;
    if (width >= 768) return 2;
    if (width >= 576) return 2;
    return 1;
  }

  function getMaxPage(perPage) {
    return Math.max(Math.ceil(items.length / perPage) - 1, 0);
  }

  function update() {
    const perPage = getPerPage();
    const maxPage = getMaxPage(perPage);
    const navigation = document.querySelector(".actus-navigation");

    if (currentPage > maxPage) {
      currentPage = maxPage;
    }

    items.forEach((item, index) => {
      if (
        index >= currentPage * perPage &&
        index < (currentPage + 1) * perPage
      ) {
        item.style.display = "block";
      } else {
        item.style.display = "none";
      }
    });

    if (indicator) {
      indicator.textContent = `${currentPage + 1} / ${maxPage + 1}`;
    }

    if (navigation) {
      if (items.length <= perPage) {
        navigation.style.display = "none";
      } else {
        navigation.style.display = "flex";
      }
    }

    if (prevBtn) {
      const disabled = currentPage === 0;
      prevBtn.disabled = disabled;
      prevBtn.style.opacity = disabled ? "0.3" : "1";
    }

    if (nextBtn) {
      const disabled = currentPage >= maxPage;
      nextBtn.disabled = disabled;
      nextBtn.style.opacity = disabled ? "0.3" : "1";
    }
  }

  if (nextBtn) {
    nextBtn.addEventListener("click", function () {
      const perPage = getPerPage();
      const maxPage = getMaxPage(perPage);

      if (currentPage < maxPage) {
        currentPage++;
        update();
      }
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener("click", function () {
      if (currentPage > 0) {
        currentPage--;
        update();
      }
    });
  }

  window.addEventListener("resize", function () {
    update();
  });

  update();
});
